<!-- 財務 -> 应收管理 -> 调货应付 -->
<template>
    <div class="templete">
        <div class="search_box search_box_f clearfix no_print">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="调货合同号"></el-input>
            <el-select class="search_select search_inputBox" v-model="params.supplier_id" placeholder="供应商" multiple filterable @visible-change="getSelectsalePurchase('supplier_id')">
                <el-option v-for="list in selectMapS.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.clerk_id" placeholder="调/退货人"  filterable @visible-change="getSelectList('creater')">
                <el-option v-for="list in selectMap.creater" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.purchase_type" placeholder="数据来源" @visible-change="getSelectList('purchasesalesType')">
                <el-option v-for="list in selectMap.purchasesalesType" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.settlement_status" placeholder="结算状态" multiple @visible-change="getSelectList('settlementTypeSelect')">
                <el-option v-for="list in  selectMap.settlementTypeSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.rec" placeholder="REC状态" @visible-change="getSelectList('recSelect')">
                <el-option v-for="list in selectMap.recSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.receipt_invoice" placeholder="收票状态" @visible-change="getSelectList('invoiceSelect')">
                <el-option v-for="list in selectMap.invoiceSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.creator_id" placeholder="制单人" filterable>
                <el-option v-for="list in selectMap.creater" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_select search_inputBox" v-model="params.remark" placeholder="备注"></el-input>
            <!-- <el-select class="search_select search_inputBox" v-model="params.status" placeholder="订单状态">
                <el-option v-for="list in purchaseStatusList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.pay_status" placeholder="付款状态">
                <el-option :value="2" label="已付"></el-option>
                <el-option :value="0" label="未付"></el-option>
                <el-option :value="1" label="部分付款"></el-option>
            </el-select> -->
            <div class="searchBtnList clearfix">
                    <!-- <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div> -->
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible;scene='purchase.sales.payments';isGlobal=false;filter=filter;"></div>
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList no_print clearfix">
            <el-button class="funcPublicBtn funcPublicBtnChecked" @click="payFunc">付款</el-button>
            <el-button class="funcPublicBtn" @click="settlement">批量结算</el-button>
            <!-- <el-button class="funcPublicBtn" @click="payOtherDeposit">其他付款</el-button> -->
        </div>
        <div class="tableBox no_print">
            <tabletem :isSetCol="true" :scene="scene" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @rowClick="rowClick" @getRow="getRow"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalName">合计：</div>
            <div class="totalNumber">调货数量:{{totalObj.total_cube}}</div>
            <div class="totalNumber">采购金额:{{totalObj.rmb_amount}}</div>
            <div class="totalNumber">应付金额:{{totalObj.payment_amount}}</div>
            <div class="totalNumber">已结金额:{{totalObj.settlement_amount}}</div>
            <div class="totalNumber">未结金额:{{totalObj.un_settlement_amount}}</div>
            <div class="totalNumber">税金:{{totalObj.tax}}</div>
            <div class="totalNumber">抹零:{{totalObj.reduce_amount}}</div>
            <div class="totalNumber">已收发票:{{totalObj.invoice_yes}}</div>
            <div class="totalNumber">未收发票:{{totalObj.invoice_no}}</div>
            <div class="totalNumber" v-if="select_price">选中应付金额:{{select_price}}</div>
            <!-- <div class="totalNumber">其他付款:{{totalObj.other_amount}}</div> -->
        </div>
        <div class="pageBox no_print">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="'调货单('+'合同号：'+form_params.contract_no+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <el-form class="clearfix dialogForm dialogFormB" :model="form_params" ref="saleorderA">
                        <div class="elFormBox">
                            <el-form-item  label="供应商名称：" class="selectCustomerNoDown">
                                <el-input v-model="form_params.supplier" :disabled="true"></el-input>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item  label="调货人：" class="selectCustomerNoDown">
                                <el-input v-model="form_params.clerk_name" :disabled="true"></el-input>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item label="调货日期：">
                                <el-date-picker v-model="form_params.contract_time" :disabled="true" type="date" placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="elFormBox elDialogElFormBoxCheckbox">
                            <img  src="/icon/operation_edits.png" @click="amend" class="form_edits">
                            <el-form-item  label="REC：">
                                <el-checkbox :disabled="true" v-model="form_params.rec" style="transform: scale(1.2)"></el-checkbox>
                                <!-- <el-input v-model="form_params.tax_rate" :disabled="true" v-if="form_params.rec" @input="calculationTableTotal(),recDigit($event)" placeholder="税率%：" class="checkbox elDialogElFormBoxCheckboxREC"></el-input> -->
                            </el-form-item>
                        </div>
                        <div class="globalFilterBtn"  @click="filterDialogVisibleB=!filterDialogVisibleB"></div>
                    </el-form>
                </el-form>
                <div class="">
                    <div class="editBox">
                        <div class="inwardRoll">
                            <el-table :data="listDetail" ref="outBoundDetailTable" border stripe highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <!-- <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div> -->
                                            <span >
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="listDetail" ref="outBoundDetailTable" border stripe highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip  v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',width_total,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.width_total }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="立方" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="单价" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',cube_price,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cube_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="金额" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',total_amount,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.total_amount }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',remark,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.remark }}
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                        <div class="dialogTotal clearfix">
                        <div class="dialogTotalC">合计应付</div>
                            <div class="dialogTotalC" v-if="form_params.rmb_amount&&form_params.rmb_amount!=0.00">采购金额:{{form_params.rmb_amount}}</div>
                            <div class="dialogTotalC" v-if="form_params.tax&&form_params.tax!=0.00">税金:{{form_params.tax}}</div>
                            <div class="dialogTotalC" v-for="(item,index) in form_params.payments" :key="index">{{item.name}}:{{item.amount}}</div>
                            <div class="dialogTotalC" v-if="form_params.unpay_amount&&form_params.unpay_amount!=0.00">应付金额:{{form_params.unpay_amount}}</div>
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" :readonly="true" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="editBtnList clearfix">
                    <div class="editPerson" style="font-size: 12px;">采购余额：{{supplier_balance}}</div>
                    <div style="float:left;">
                        <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                                <!-- <img src="../../assets/top-delete-suspension.png" v-if="form_params.id==''" class="newFeeImg" @click="delOutFee(index)"/> -->
                            </div>
                        </div>
                    </div>
                    <div class="editBtn">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="addDialogVisibleBack = true;add_params.supplier_id = form_params.supplier_id;add_params.ids = [form_params.id];add_params.contract_no = form_params.contract_no;purchaseShow =true">付款</el-button>
                        <el-button class="funcPublicBtn" @click="purchaseSettlement()">结算</el-button>
                        <el-button class="funcPublicBtn" @click="openBill">收发票</el-button>
                        <!-- <el-button class="funcPublicBtn" @click="print(8)">合同打印</el-button> -->
                        <el-button class="funcPublicBtn" @click="print(0)">打印</el-button>
                        <el-button class="funcPublicBtn" @click="exportExcelBill">导出</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->

        <!-- 采购退货单 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleB" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="'采购退货单('+form_params.contract_no+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <el-form class="clearfix dialogForm dialogFormB" :model="form_params" ref="saleorderA">
                        <div class="elFormBox">
                            <el-form-item  label="供应商名称：" class="selectCustomerNoDown">
                                <el-input v-model="form_params.supplier" :disabled="true"></el-input>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item  label="退货人：" class="selectCustomerNoDown">
                                <el-input v-model="form_params.returner_name" :disabled="true"></el-input>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item label="退货日期：">
                                <el-date-picker v-model="form_params.contract_time" :disabled="true" type="date" placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="elFormBox elDialogElFormBoxCheckbox">
                            <!-- <img  src="/icon/operation_edits.png" @click="amend" class="form_edits"> -->
                            <el-form-item  label="REC：">
                                <el-checkbox :disabled="true" v-model="form_params.rec"></el-checkbox>
                                <el-input v-model="form_params.tax_rate" :disabled="true" v-if="form_params.rec"  placeholder="税率%：" class="checkbox elDialogElFormBoxCheckboxREC"></el-input>
                            </el-form-item>
                        </div>
                        <div class="globalFilterBtn" click="filterDialogVisibleB=!filterDialogVisibleB"></div>
                    </el-form>
                </el-form>
                <div class="">
                    <div class="editBox">
                        <div class="inwardRoll">
                            <el-table :data="listDetail" ref="outBoundDetailTable" border stripe highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <!-- <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div> -->
                                            <span >
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="listDetail" ref="outBoundDetailTable" border stripe highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip  v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',width_total,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.width_total }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="立方" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="单价" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',cube_price,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cube_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="金额" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',total_amount,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.total_amount }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',remark,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.remark }}
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                        <div class="dialogTotal clearfix">
                        <div class="dialogTotalC">合计应收</div>
                            <div class="dialogTotalC" v-if="form_params.rmb_amount&&form_params.rmb_amount!=0.00">退货金额:{{form_params.rmb_amount}}</div>
                            <div class="dialogTotalC" v-if="form_params.tax&&form_params.tax!=0.00">税金:{{form_params.tax}}</div>
                            <div class="dialogTotalC" v-if="form_params.unpay_amount&&form_params.unpay_amount!=0.00">应退金额:{{form_params.unpay_amount}}</div>
                        </div>
                    </div>
                    <div class="returnReason">
                        <textarea class="remarkTextarea" :readonly="true" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                    <div class="editLeft">
                        <textarea class="remarkTextarea" :readonly="true" v-model="form_params.ship_no" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                    <!-- <div class="editPerson">审核人：{{form_params.auditor_name}}</div> -->
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="editBtnList clearfix">
                    <div class="editPerson" style="font-size: 12px;">采购余额：{{supplier_balance}}</div>
                    <div style="float:left;">
                        <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                                <!-- <img src="../../assets/top-delete-suspension.png" v-if="form_params.id==''" class="newFeeImg" @click="delOutFee(index)"/> -->
                            </div>
                        </div>
                    </div>
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="print(0)">打印</el-button>
                        <el-button class="funcPublicBtn" @click="exportExcelBill">导出</el-button>
                        <el-button class="funcPublicBtn" @click="purchaseReceiptSettlement()">结算</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="addDialogVisiblereceipt = true;add_receipt.supplier_id = form_params.supplier_id;add_receipt.id = form_params.id;add_receipt.amount = supplier_balance;add_receipt.contract_no = form_params.contract_no;purchaseShow =true">退款</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->

        <!-- 新增付款单 dialog START -->
        <el-dialog v-dialog-drag title="付款单" :visible.sync="addDialogVisibleBack" class="eldialog no_print eldialogLine auto" :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" :rules="addDialogRules" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="采购合同号：" v-if="purchaseShow">
                        <el-input v-model="add_params.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：" prop="account_id">
                        <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                        <!-- <el-input v-model="add_params.account_name"></el-input> -->
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        <el-select v-model="add_params.supplier_id" placeholder="" filterable disabled @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="add_params.bill_type" disabled placeholder="" >
                            <el-option :value="0"  label="采购退款"></el-option>
                            <el-option :value="1"  label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付款方式：" prop="payment_type_id">
                        <el-select v-model="add_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="add_params.course_title" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="付款¥金额：" prop="amount">
                        <el-input v-model="add_params.amount" @input.native="changeRate($event,add_params.amount)"  placeholder=""></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="发票：">
                        <el-select v-model="add_params.is_invoice" placeholder="" >
                            <el-option :value="0"  label="未开"></el-option>
                            <el-option :value="1"  label="已开"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item prop="pay_file" style="height: auto;" >
                                     <span slot="label"><span>付款凭证：</span>
                                </span>
                        <ym-upload ref="payUp" :limit="5" :init-list="fileListShow" :disabled="false" :form-param.sync="add_params.files"></ym-upload>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisibleBack=!addDialogVisibleBack">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderSheetBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增收款单 dialog END -->
        <!-- 收款单 dialog START -->
        <el-dialog v-dialog-drag title="采购退货退款单" :visible.sync="addDialogVisiblereceipt" class="eldialog no_print eldialogLine auto" :modal="false" custom-class="full_dialog">
            <el-form :model="add_receipt" :rules="addDialogRules" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="采购合同号：" v-if="purchaseShow">
                        <el-input v-model="add_receipt.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：" prop="account_id">
                        <el-select v-model="add_receipt.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                        <!-- <el-input v-model="add_params.account_name"></el-input> -->
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        <el-select v-model="add_receipt.supplier_id" placeholder="" filterable disabled @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="add_receipt.bill_type" disabled placeholder="" >
                            <el-option :value="0"  label="收入"></el-option>
                            <el-option :value="1"  label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易方式：" prop="payment_type_id">
                        <el-select v-model="add_receipt.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="add_receipt.course_title" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="应退金额：" prop="amount">
                        <el-input v-model="add_receipt.amount" @input.native="changeRate($event,add_receipt.amount)"  placeholder=""></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="发票：">
                        <el-select v-model="add_params.is_invoice" placeholder="" >
                            <el-option :value="0"  label="未开"></el-option>
                            <el-option :value="1"  label="已开"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item prop="pay_file" style="height: auto;" >
                                     <span slot="label"><span>付款凭证：</span>
                                </span>
                        <ym-upload ref="payUp" :limit="5" :init-list="fileListShow" :disabled="false" :form-param.sync="add_receipt.files"></ym-upload>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_receipt.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisiblereceipt=!addDialogVisiblereceipt">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addReceipt">确定</el-button>
            </div>
        </el-dialog>
        <!-- 收款单 dialog END -->
        <!-- 发票金额 dialog START -->
        <!-- <el-dialog v-dialog-drag title="发票金额" :visible.sync="addDialogVisibleBill" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_billParams" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="金额：">
                        <el-input v-model="add_billParams.invoice_yes" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisibleBill=!addDialogVisibleBill">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderBill">确定</el-button>
            </div>
        </el-dialog> -->
        <!-- 发票金额 dialog END -->
        <!-- 开发票 dialog START -->
        <el-dialog v-dialog-drag title="收票" :visible.sync="addDialogVisibleBill" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_billParams" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="发票抬头：">
                        <el-input v-model="add_billParams.title" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票名称：">
                        <el-input v-model="add_billParams.name" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票号码：">
                        <el-input v-model="add_billParams.code" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票金额：">
                        <el-input v-model="add_billParams.amount" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="采购单号：">
                        <el-input v-model="add_billParams.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_billParams.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisibleBill=!addDialogVisibleBill">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderBill">确定</el-button>
            </div>
        </el-dialog>
        <!-- 开发票 dialog END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="purchase.sales.payments" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 单据里面列配置 START -->
        <filter-fields :tableData="filters" scene="purchase.sales.payment.info" :isGlobal="isGlobal" :filterDialogVisible="filterDialogVisibleB" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleB = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!--查看已开票 START-->
        <el-dialog v-dialog-drag  :visible.sync="dialogVisibleBill" class="eldialog eldialogStock" width="920px" :modal="false" title="开票记录" custom-class="full_dialog">
            <pay-list-dialog ref="selectStock" :id="seeBillList_id" :type="2"></pay-list-dialog>
        </el-dialog>
        <!--查看已开票 END-->
        <!--REC START -->
        <el-dialog  v-dialog-drag title="税金修改" :visible.sync="recChanges"
                width="350px" class="eldialog no_print eldialogLine" :model="false" custom-class="full_dialog">
            <el-form :model="rec_params" :rules="recRules"  :inline="true" class="dialogFormB clearfixe"
                size="mini">
                <div class="eldialogFormBox">
                    <el-form-item label="REC：" >
                        <el-checkbox class="taxCheck" v-model="rec_params.rec" style="margin-right: 10px;transform: scale(1.2)" ></el-checkbox>
                        <!-- <el-input  v-model="rec_params.tax_rate"  style="width:145px;" v-digits:4="rec_params.tax_rate" @input="change($event)" class="formInput tax_rate">
                        </el-input>
                        <span style="position: absolute;right: 5px;">%</span> -->
                    </el-form-item>
                    <el-form-item label="是否含票价：" v-if="rec_params.rec">
                        <el-select v-model="rec_params.with_ticket" placeholder="" >
                            <el-option :value="0"  label="否"></el-option>
                            <el-option :value="1"  label="是"></el-option>
                        </el-select>
                    </el-form-item> 
                    <el-form-item  label="税率："  v-if="rec_params.with_ticket==0&&rec_params.rec" class="dialogTwo clearfix" prop="tax_rate" >
                        <el-select class="twoSelect" v-model="rec_params.rec_type" @change="TaxesTableTotal()" placeholder="" >
                            <el-option :value="'MUL'"  label="×"></el-option>
                            <el-option :value="'DIV'"  label="÷"></el-option>
                        </el-select>
                        <!-- @input="exchangeRate" -->
                        <el-input class="twoInput" @input="TaxesTableTotal()" v-model="rec_params.tax_rate"></el-input>
                    </el-form-item>
                    <el-form-item label="税金：" v-if="rec_params.with_ticket==0&&rec_params.rec">
                        <el-input class="formInput" v-model="rec_params.amount" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="税金：" v-if="rec_params.with_ticket==1&&rec_params.rec">
                        <el-input class="formInput" v-model="rec_params.amount"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <textarea style="min-height: 60px;" class="edit_input edit_textarea formInput" v-model="rec_params.remark">
                        </textarea>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="outRecChanges()">取消</el-button>
                <el-button  class="publicBtn dialogBtn"  @click="settlementConfirm">确定</el-button>
            </div>
        </el-dialog>
        <!--REC END -->
         <!-- 列表修改 dialog START -->
         <!-- 结算确认单 dialog START -->
        <el-dialog v-dialog-drag title="结算确认" :visible.sync="addSettlementDialog" class="eldialog no_print eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="settlement_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="结算日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="采购余额：" class="other_form_item">
                        <div style="text-align:left;">{{supplier_balance}}</div>
                    </el-form-item>
                    <el-form-item label="未结金额：" class="other_form_item">
                        <div style="text-align:left;">{{form_params.un_settlement_amount}}</div>
                    </el-form-item>
                    <el-form-item label="结算金额¥：">
                        <el-input v-model="settlement_params.amount"   placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="抹零：" v-if="selectRow.length<2">
                        <el-input v-model="settlement_params.reduce_amount" @input.native="changeReduceAmount($event,settlement_params.reduce_amount)" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input type="textarea" :rows="3" v-model="settlement_params.remark"></el-input>
                        <!-- <el-input v-model="settlement_params.remark" placeholder=""></el-input> -->
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix" style="margin-top: 60px;">
                <el-button class="dialogBtn funcPublicBtn" @click="addSettlementDialog=!addSettlementDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addsettlementBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 结算确认单 dialog END -->
        <!-- 结算确认单 dialog START -->
        <el-dialog v-dialog-drag title="结算确认" :visible.sync="addReceiptSettlementDialog" class="eldialog no_print eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="receipt_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="结算日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="采购余额：" class="other_form_item">
                        <div style="text-align:left;">{{supplier_balance}}</div>
                    </el-form-item>
                    <el-form-item label="结算金额¥：">
                        <el-input v-model="receipt_params.amount"   placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="抹零：">
                        <el-input v-model="receipt_params.reduce_amount" @input="notCountTheSmallChangeReceiptTotal()" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input type="textarea" :rows="3" v-model="receipt_params.remark"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix" style="margin-top: 60px;">
                <el-button class="dialogBtn funcPublicBtn" @click="addReceiptSettlementDialog=!addReceiptSettlementDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addReceiptSettlementBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 结算确认单 dialog END -->
        <!-- 其他付款单 dialog START -->
        <el-dialog v-dialog-drag title="其他付款单" :visible.sync="addOtherDepositDialog" class="eldialog no_print eldialogLine auto" :modal="false" custom-class="full_dialog">
            <el-form :model="otherDeposit_params" :rules="otherRules" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="采购合同号：" v-if="purchaseShow">
                        <el-input v-model="otherDeposit_params.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：" prop="account_id">
                        <el-select v-model="otherDeposit_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        <el-select v-model="otherDeposit_params.supplier_id" placeholder="" filterable disabled @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="otherDeposit_params.bill_type" disabled placeholder="" >
                            <el-option :value="0"  label="收入"></el-option>
                            <el-option :value="1"  label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付款方式：" prop="payment_type_id">
                        <el-select v-model="otherDeposit_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="费用名称：">
                        <el-input v-model="otherDeposit_params.course_title" disabled placeholder=""></el-input>
                        <!-- <el-select v-model="otherDeposit_params.fee_id" placeholder="" @visible-change="getSelectList('purchaseCost')">
                            <el-option v-for="item in selectMap.purchaseCost" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select> -->
                    </el-form-item>
                    <!-- <el-form-item label="科目名称：">
                        <el-input v-model="otherDeposit_params.course_title" disabled placeholder=""></el-input>
                    </el-form-item> -->
                    <el-form-item label="¥付款金额：" prop="amount">
                        <el-input v-model="otherDeposit_params.amount"  placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item prop="pay_file" style="height: auto" >
                                     <span slot="label"><span>付款凭证：</span>
                                </span>
                        <ym-upload ref="payUp" :limit="5" :init-list="fileListShow" :disabled="false" :form-param.sync="otherDeposit_params.files"></ym-upload>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="otherDeposit_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addOtherDepositDialog=!addOtherDepositDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addotherDepositBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 其他付款单 dialog END -->
        <el-dialog v-dialog-drag title="其他付款修改" :visible.sync="otherVisible" width="460px !important" class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <div class="eldialogFormBox">
                    <el-form-item label="其他付款" class="other_form_item" style="width:80%">
                        <el-input v-model="listDetailObj.other_amount" @input.native="changeOther($event,listDetailObj.other_amount)" placeholder=""></el-input>
                    </el-form-item>
                </div>
                <textarea class="edit_input edit_textarea" placeholder="备注" style="width:65%;"  v-model="listDetailObj.other_amount_remark"></textarea>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn"  @click="otherChangeSure">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="outOtherVisible()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog v-dialog-drag title="抹零修改" :visible.sync="reduceVisible" width="460px !important" class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <div class="eldialogFormBox">
                    <el-form-item label="抹零" class="other_form_item" style="width:80%">
                        <el-input v-model="listDetailObj.reduce_amount" @input.native="changeReduce($event,listDetailObj.reduce_amount)" placeholder=""></el-input>
                    </el-form-item>
                </div>
                <textarea class="edit_input edit_textarea" placeholder="备注" style="width:65%;"  v-model="listDetailObj.reduce_amount_remark"></textarea>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn"  @click="reduceChangeSure">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="outReduceVisible()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <!-- 其他应付详情 START -->
        <el-dialog v-dialog-drag :visible.sync="otherDetailFlag" class="eldialog specTable" width="820px" :modal="false" title="其他付款详情" custom-class="full_dialog">
             <el-table :data="otherDetail" border stripe highlight-current-row size="mini" height="100%" style="max-height:400px">
                 <el-table-column key="1" type="index" label="序号" align="center" width="50"></el-table-column>
                 <el-table-column key="2" label="操作" width="50">
                     <template slot-scope="scope">
                         <div class="icon_wrap">
                             <i class="operation_delete" @click="otherDetailDelete(scope.$index,scope.row.id)" title="删除"></i>
                         </div>
                     </template>
                 </el-table-column>
                 <el-table-column label="添加日期" prop="trading_time" show-overflow-tooltip></el-table-column>
                 <el-table-column label="费用名称" prop="course_title" show-overflow-tooltip></el-table-column>
                 <el-table-column label="其他付款" prop="rmb_amount" show-overflow-tooltip></el-table-column>
                 <el-table-column label="操作人" prop="operator_name" show-overflow-tooltip></el-table-column>
                 <el-table-column label="凭证" prop="files" show-overflow-tooltip>
                     <template slot-scope="scope">
                         <viewer :images="scope.row.files"> 
                             <img v-for="(src,index) in scope.row.files" v-show="index < 1" class="viewImg" :src="src" :key="index"/>
                         </viewer>
                     </template>
                 </el-table-column>
                 <el-table-column label="备注" prop="operator_name" show-overflow-tooltip></el-table-column>
             </el-table>
             <div style="height: 34px;text-align: left;">
                 <div style="padding: 5px;font-size: 15px;">
                     <span>合计：费用金额：{{otherTotal.fc_amount}}</span>
                 </div>
             </div>
         </el-dialog>
         <!-- 其他应付详情 END -->
    </div>
</template>
<style scoped lang="scss">

    .piaoMess{font-size: 12px;color:#777;margin-bottom:10px;}
    .piaoMessC{float: left;width:50%;}
    .order_header{
        font-size:26px; font-weight:bold; line-height:37px; color: #333333; text-align: center; position: relative; top: 15px;
        .code{ left: 50%; position: absolute; margin-left: 154px; font-size: 12px; color: #333333; }
    }
    .bottom_flex{ padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;padding:2px 0;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;margin-right:20px;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }

    .sub_container{
        display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff;
        .filter_path{
            padding: 15px; background-color: #F4F5F9; margin-bottom: 12px;
            .form-inline{
                & > div{
                    margin-right: 20px;
                    button { margin-left: 15px; }
                }
            }
            .filter_input{
                width: 123px;
            }
        }
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 0px 0 6px;
            // .excel_btn{
            //     color: #B21111; cursor: pointer;
            // }
        }
        .table_path{ flex: 1; }
        .statistics{
            background: #F7F8FA; padding: 12px 23px; line-height:18px; margin-top: 10px; display: flex; align-items: flex-start; font-size: 15px; color: #333333;
            & > div:last-child{
                flex: 1; margin-left: 26px;
                & > div:last-child{
                    margin-top: 17px;
                }
                & > div > span + span{ margin-left: 80px; }
            }
        }
        // dialog START
        .order_header{
            font-size:26px; font-weight:bold; line-height:37px; color: #333333; text-align: center; position: relative; top: 15px;
            .code{ left: 50%; position: absolute; margin-left: 154px; font-size: 12px; color: #333333; }
        }
        .order_dialog{
            .edit_select{ width: 151px; }
            .edit_input{ width: 116px; }
            .order_base{ margin-bottom: 15px; }
            .flex{
                display: flex; align-items: center; justify-content: space-between;
                & > div { margin-bottom: 12px; }
                .edit_input{ width: 151px; }
            }
            .order_other{
                display: flex; align-items: stretch; border: 1px solid #707070; border-left: 0px none;
                & > div{ flex: 1; border-left: 1px solid #707070; }
                & > div:first-child{ padding: 11px 0 9px 50px; }
                .label_no_padding_form > div{ margin-bottom: 4px; }
                .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
            }
            .order_footer{ display: flex; font-size:16px; line-height:22px; display: flex; padding: 8px 28px 0 32px; align-items: center; justify-content: space-between; }
        }
        .dialog-footer{ display: flex; align-items: center; justify-content: space-between; font-size:16px; color: #333333; }
        // dialog END
        // add_dialog START
        .add_dialog_form{
            & > div{ margin-bottom: 9px; }
            .btn_row{ padding-top: 23px; text-align: center; }
            .edit_input{ width: 100%; }
        }
        // add_dialog END
        // sure_dialog START
        .sure_dialog_form{
            & > div{ margin-bottom: 15px; }
            .btn_row{ padding-top: 23px; text-align: right; }

            .remark{
                display: flex; align-items: stretch; justify-content: space-between; background: #fff; color: #000000; font-size: 12px; padding: 5px 12px;
                textarea{ background: #FFFFFF; border-radius:3px; height:84px; resize: none; border: 0px none; outline: none; flex: 1;  }
            }
        }

        // sure_dialog END
    }
    .form_edits{width:20px;position: absolute;left: 20px;}
    .checkbox {zoom: 100%;}
</style>
<script>
    import bus from "../../eventBus";
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                companyName:localStorage.dw_erp_company_name,
                dialogVisibleBill:false,
                seeBillList_id:"",
                tableLoading:false,
                billColumn:"",
                listDetail:[],
                dialogVisible:false,
                dialogVisibleB:false,
                printDetail:{
                    fields:"",
                    statistic:{
                        total_count:"",
                        total_amount:"",
                        total_cube:""
                    }
                },
                printTotal:[],
                companyName:localStorage.dw_erp_company_name,
                addDialogVisibleBill:false,
                add_billParams:{
                    // id:"",
                    // invoice_yes:""
                    invoice_time:"",
                    title:"",
                    purchase_id:"",
                    contract_no:"",
                    name:"增值税专用发票",
                    code:"",
                    amount:"",
                    remark:""
                },

                module:localStorage.dw_erp_power_code,
                enableConfig:localStorage.dw_erp_enable_config,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                isShowMore:false,
                isGlobal:false,
                companyName:localStorage.dw_erp_company_name,
                scene:"purchase.sales.payments",
                start_time: "",
                end_time: "",
                params:{
                    page:1,
                    per_page:50,
                    start_time:"",
                    end_time:"",
                    contract_no:"",
                    supplier_id:"",
                    creator_id:"",
                },
                last_page: 10,
                total:0,
                list : [],
                selectMap:{
                    customer:[],
                    creater:[],
                    account:[],
                    paymentType:[],
                    lockLevel:[],
                    purchasesalesType:[],
                    settlementTypeSelect:[],
                },
                selectMapS:{
                    supplier_id:[],
                },
                // 新增收款单 dialog START
                order_sn : "",
                trading_time : new Date(),
                add_params : {
                    ids:[],
                    contract_no:"",
                    trading_time:"",
                    account_name:"",
                    supplier_id:"",
                    payment_type_id:"",
                    bill_type:1,
                    course_title:"调货付款",
                    amount:"",
                    // is_invoice:"",
                    files:[],
                    remark:"",
                },
                // 新增收款单 dialog END
                // dialog START
                addDialogVisibleBack:false,
                addDialogVisiblereceipt:false,
                add_receipt:{
                    id:'',
                    contract_no:"",
                    trading_time:"",
                    account_name:"",
                    supplier_id:"",
                    payment_type_id:"",
                    bill_type:0,
                    course_title:"采购退款",
                    amount:"",
                    // is_invoice:"",
                    files:[],
                    remark:"",
                },
                newFee:[],
                form_params:{
                    id:"",
                    supplier:"",
                    contract_time:"",
                    linkman:"",
                    phone:"",
                    remark:"",
                    is_request_review:0,
                    tax_rate:"",
                    rec:0,
                    details:[],
                    fee_list:[]
                },
                invoice_time:"",
                // DIALOG END
                tableCol:[
                    {colName:"调货合同号",colKey:"contract_no",colWidth:190,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"数据来源",colKey:"purchase_type_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"订单状态",colKey:"status_text",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"调货日期",colKey:"contract_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供应商名称",colKey:"supplier",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"品名",colKey:"breed",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"调货数量",colKey:"order_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"采购金额",colKey:"rmb_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"应付金额",colKey:"pay_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"已结金额",colKey:"settlement_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"未结金额",colKey:"un_settlement_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // htmlNodeFunc(row) {let _color = row['un_payment_amount_color'];
                    //         return `<span style="color:${_color}">${row[this.colKey]}</span>`;
                    //     },
                    // {colName:"其他付款",colKey:"other_amount",colWidth:90,isSetWidth:true,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true,isCanClickUnInclude:',0,'},
                    // {colName:"付款人",colKey:"oppayer_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"含票价税金",colKey:"ticket_tax",colWidth:90,isSetWidth:true,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"税金",colKey:"tax",colWidth:90,isSetWidth:true,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"抹零",colKey:"reduce_amount",colWidth:90,isSetWidth:true,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true,isCanClickUnInclude:',0,'},
                    {colName:"REC状态",colKey:"rec_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"已收发票",colKey:"invoice_yes",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"未收发票",colKey:"invoice_no",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"查看详情",colKey:"see",colWidth:85,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"调/退货人",colKey:"clerk_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                selectRow:[],
                totalObj:{},
                filterDialogVisible:false,
                filterDialogVisibleB:false,
                filter:"",
                filters: [],
                fields:"",
                tableTotal:{
                  sales_amount:0.00,
                  tax:0.00,
                  discount_amount:0.00,
                  tax_amount:0.00,
                  traffic_amount:0.00,
                  other_amount:0.00,
                  reduce_amount:0.00,
                  receivable_amount:0.00,
                  invoice_no:0.00,
                  invoice_yes:0.00
                },
                purchaseStatusList:[],
                rec_params:{
                    rec:'',
                    rec_type:'MUL',
                    with_ticket:'',
                    tax_rate:'',
                    amount:'',
                    remark:'',
                },
                recChanges:false,
                f_rec:'',
                otherVisible:false,
                reduceVisible:false,
                sure_params : {
                    order_id : "",
                    amount : "",
                    reduce_amount:"",
                    remark : ""
                },
                listDetailObj:{
                    id: "",
                    reduce_amount:"",
                    reduce_amount_remark:"",
                    other_amount:"",
                    other_amount_remark:"",
                },
                purchaseShow:false,
                otherDetailFlag:false,//其他付款详情弹框
                otherDetail:[],
                otherTotal:{},
                fileListShow:[],
                addSettlementDialog:false,//结算确认单
                settlement_params:{
                    amount:'',
                    remark:'',
                    reduce_amount:'',
                },
                addReceiptSettlementDialog:false,//退货结算确认
                receipt_params:{
                    amount:'',
                    remark:'采购退款到余额',
                    reduce_amount:'',
                },
                paymentAmount:'',//付款金额
                purchaseBalance:'',//采购金额
                amountPayable:"",//应付金额
                addOtherDepositDialog:false,//其他应付弹框
                otherDeposit_params : {
                    id:'',
                    contract_no:"",
                    trading_time:"",
                    account_id:"",
                    supplier_id:"",
                    payment_type_id:"",
                    bill_type:1,
                    course_title:"其他付款",
                    amount:"",
                    remark:"",
                    files:[],
                },
                recRules:{
                    tax_rate: [{ required: true, message: '不能为空', trigger: 'change' }],
                },
                addDialogRules:{
                    account_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    payment_type_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    amount: [{ required: true, message: '不能为空', trigger: 'change' }],
                },
                otherRules:{
                    account_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    payment_type_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    amount: [{ required: true, message: '不能为空', trigger: 'change' }],
                },
                supplier_balance:'',
                amountB:'',
                select_price:'',
            }
        },
        created() {
            this.getSelectList("supplier")
            this.getSelectList("invoiceSelect")
            this.getSelectList("settlementTypeSelect")
            this.getSelectList("creater")
             this.getSelectList("recSelect")
            this.getPurchaseStatusList()
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
             headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.sceneIn).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            getSelectsalePurchase(target){
                this.$getSelectsalePurchase(target,{supplier_id:this.params.supplier_id,settlement_status:this.params.settlement_status}).then(res=>{
                    this.selectMapS[res.data.data.target]=res.data.data.result;
                })
            },
            //点击开发票
            openBill(){
                this.invoice_time=new Date();
                this.add_billParams.title = this.companyName;
                this.add_billParams.purchase_id=this.form_params.id;
                this.add_billParams.contract_no=this.form_params.contract_no;
                this.addDialogVisibleBill=!this.addDialogVisibleBill;
                this.selectMap.customer.forEach(item=>{
                    if(item.id==this.form_params.customer_id){
                        this.add_billParams.title=item.name;
                    }
                })
            },
            amend(){
                this.recChanges = !this.recChanges;
                this.f_rec = this.form_params.rec;
                // this.rec_params.tax_rate = this.form_params.tax_rate;
                this.rec_params.id = this.form_params.id;
            },
            outRecChanges(){
                this.recChanges = false;
            },
            settlementConfirm(){
                if(this.rec_params.rec==true){
                    this.f_rec=1
                }else{
                    this.f_rec=0
                }
                this.rec_params.rec = this.f_rec;
                if(this.rec_params.with_ticket==1){
                    delete this.rec_params.rec_type;
                    delete this.rec_params.tax_rate;
                }
                this.postFunc('/erp/purchase.sales.rec',this.rec_params,()=>{
                    this.outRecChanges();
                    this.tip("修改成功", "success");
                    this.recChanges = false;
                    this.dialogVisible = false;
                    // this.postFuncLoading("/erp/cloud.purchase.view",{id:this.rec_params.id},res=>{
                    //     this.form_params = res.data.data.list;
                    //     if(this.form_params.rec == 0){
                    //         this.form_params.rec =false
                    //     }else{
                    //         this.form_params.rec =true
                    //     }
                    //     this.form_params.contract_time = res.data.data.list.contract_time * 1000;
                    //     this.listDetail = res.data.data.list.details;
                    //     this.newFee = res.data.data.list.fee_list;
                    //     this.scene = 'cloud.purchase.view';
                    //     this.isGlobal = true;
                    //     this.getBillColumn()
                    //     this.dialogVisible = true;
                    //     this.calculationTableTotal()
                    // },error=>{
                    //     this.tip(error.data.message,"warning")
                    // })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //结算
            settlement(){
                let num = 0;
                let ids = [];
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning");
                    return
                }
                // else if(this.selectRow.length>1){
                //     this.tip("请选择单条数据","warning");
                //     return
                // }
                for(let i=0; i<this.selectRow.length;i++){
                    if(this.selectRow[0].supplier_id !=this.selectRow[i].supplier_id){
                        this.tip("结算，供应商必须相同！","warning");
                        return
                    }else if(this.selectRow[0].foreign_currency_id !=this.selectRow[i].foreign_currency_id){
                        this.tip("结算，币种必须相同！","warning");
                        return
                    }else if(this.selectRow[i].purchase_type==6){
                        this.tip("采购退货单请到详情结算","warning");
                        return
                    }
                    else{
                        ids.push(this.selectRow[i].id);
                    }
                    num = i;
                }
                this.form_params.rmb_amount = this.selectRow[0].rmb_amount;
                let result = this.$amountTo(this.selectRow, 'un_settlement_amount');
                this.form_params.un_settlement_amount = result;
                if(this.selectRow.length==1){
                    this.settlement_params.reduce_amount = this.selectRow[0].reduce_amount;
                    this.amountB = this.selectRow[0].un_settlement_amount;
                }else{
                    this.amountB = this.$amountTo(this.selectRow, 'un_settlement_amount');

                }
                this.settlement_params.ids = ids;
                this.addSettlementDialog = true;
                this.currencyChange();
                this.purchaseShow =false;
            },
            //结算获取金额
            currencyChange(){
                let obj ={};
                if(this.dialogVisible == true){
                    obj.ids =  [this.form_params.id];
                }else{
                    obj.ids = this.settlement_params.ids;
                }
                this.postFunc("/erp/purchase.currency.amount",obj,res=>{
                    this.supplier_balance = res.data.data.purchase_balance;
                    this.form_params.un_settlement_amount = res.data.data.amount;
                    this.settlement_params.amount = res.data.data.amount;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //点击结算
            purchaseSettlement(){
                this.settlement_params.ids = [this.form_params.id];
                this.settlement_params.amount = this.form_params.unpay_amount;
                this.amountB = this.form_params.un_settlement_amount;
                this.settlement_params.reduce_amount = this.form_params.reduce_amount;
                this.settlement_params.un_settlement_amount = this.form_params.un_settlement_amount;
                this.addSettlementDialog = true;
                this.purchaseShow =true;
                this.currencyChange();
            },
            //结算确认
            addsettlementBack(){
                this.$confirm('是否确认结算?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.settlement_params.trading_time=parseInt(this.trading_time.getTime()/1000);
                    this.postFuncLoading("/erp/purchase.sales.settlement",this.settlement_params,()=>{
                        this.tip("结算成功","success")
                        this.addSettlementDialog=false;
                        this.dialogVisible = false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            changeReduceAmount(e,input){
                e.target.value=(e.target.value.match(/^\-?\d*(\.?\d{0,2})/g)[0]) || null
                this.input=e.target.value
                this.settlement_params.reduce_amount=this.input
            },
            //抹零计算
            notCountTheSmallChangeTotal(){    
                // console.log(this.amountB,this.settlement_params.reduce_amount)            
                if((0<Number(this.settlement_params.reduce_amount) && Number(this.settlement_params.reduce_amount)<Number(this.settlement_params.amount))||Number(this.settlement_params.reduce_amount)==''){
                    // console.log(this.settlement_params.reduce_amount,111)            

                    if(this.settlement_params.reduce_amount==""){
                        this.settlement_params.amount = this.amountB;
                    }else{
                        this.settlement_params.amount =  this.$bc_sub(Number(this.amountB),Number(this.settlement_params.reduce_amount))
                    }
                    // console.log(this.settlement_params.reduce_amount,222)            

                }else if(Number(this.settlement_params.reduce_amount)>Number(this.amountB)){
                    this.tip("抹零金额得小于结算金额"+this.amountB,"warning")
                }else{
                    console.log(this.settlement_params.reduce_amount,333)            

                } 
            },
            //结算金额限制
            amountChangeTotal(){
                if(Number(this.settlement_params.amount)>Number(this.amountB)){
                    this.settlement_params.amount = this.amountB;
                    this.tip("结算金额不能大于未结金额"+this.amountB,"warning")
                }
            },
            //退货点击结算
            purchaseReceiptSettlement(){
                this.addReceiptSettlementDialog = true;
                this.receipt_params.id = this.form_params.id;
                this.receipt_params.amount = this.form_params.unpay_amount;
                this.purchaseShow =true;
            },
            //退货结算确认
            addReceiptSettlementBack(){
                this.$confirm('是否确认结算?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.receipt_params.trading_time=parseInt(this.trading_time.getTime()/1000);
                    this.postFuncLoading("/erp/purchase.return.settlement",this.receipt_params,()=>{
                        this.tip("结算成功","success")
                        this.addReceiptSettlementDialog=false;
                        this.dialogVisible = false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //其他应付
            payOtherDeposit(){
                let num = 0;
                let ids = [];
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning");
                    return
                }else if(this.selectRow.length>1){
                    this.tip("请选择单条数据","warning");
                    return
                }
                // for(let i=0; i<this.selectRow.length;i++){
                //     if(this.selectRow[0].supplier_id !=this.selectRow[i].supplier_id){
                //         this.tip("付款，供应商必须相同！","warning");
                //         return
                //     }else{
                //         ids.push(this.selectRow[i].id);
                //     }
                //     num = i;
                // }
                if(this.selectRow.length>1){
                    this.addOtherDepositDialog = true;
                    this.otherDeposit_params.id = this.selectRow[0].id;;
                    this.otherDeposit_params.supplier_id = this.selectRow[0].supplier_id;
                    this.otherDeposit_params.currency_id = this.selectRow[0].foreign_currency_id==0?'':this.selectRow[0].foreign_currency_id;
                    this.purchaseShow =false
                }else if(this.selectRow.length==1){
                    this.otherDeposit_params.contract_no = this.selectRow[0].contract_no;
                    this.addOtherDepositDialog = true;
                    this.otherDeposit_params.id = this.selectRow[0].id;;
                    this.otherDeposit_params.supplier_id = this.selectRow[0].supplier_id;
                    this.otherDeposit_params.currency_id = this.selectRow[0].foreign_currency_id==0?'':this.selectRow[0].foreign_currency_id;
                    this.purchaseShow =true
                }
            },
            //其他付款确认
            addotherDepositBack(){
                this.$confirm('是否确认付款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.otherDeposit_params.trading_time=parseInt(this.trading_time.getTime()/1000)
                    delete this.otherDeposit_params.bill_type;
                    delete this.otherDeposit_params.supplier_id;
                    delete this.otherDeposit_params.contract_no;
                    this.postFuncLoading("/erp/purchase.sales.other.payment",this.otherDeposit_params,()=>{
                        this.tip("付款成功","success")
                        this.addOtherDepositDialog=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //开发票
            addOrderBill(){
                this.$confirm('是否确认收票?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_billParams.invoice_time=this.formatTimeZero(this.invoice_time)
                    this.postFuncLoading("/erp/cloud.purchase.invoice",this.add_billParams,()=>{
                        this.tip("操作成功","success")
                        this.addDialogVisibleBill=false;
                        // this.dialogVisible=false;
                        // this.getBillMess(this.form_params.customer_id)
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            TaxesTableTotal(){
                //计算税金
                if (Number(this.rec_params.rec) === 1) {
                    let tax_amount = 0;//税金 （2种计算方式）this.form_params.rec_type
                    if(this.tableTotal.tax_rec_amount) tax_rec_amount = Number(this.tableTotal.tax_rec_amount);
                    let rmb_amount = Number(this.form_params.rmb_amount);
                    let tax_rate = Number(this.rec_params.tax_rate);
                    let tax_rate_real = this.$bc_div(tax_rate, 100);//税率
                    if (this.rec_params.rec_type === 'DIV') {
                        //除法计算方式
                        tax_amount = this.$bc_sub(this.$bc_div(rmb_amount, this.$bc_sub(1, tax_rate_real)),rmb_amount);
                    }else{
                        //乘法计算方式
                        tax_amount = this.$bc_mul(rmb_amount, tax_rate_real);
                    }
                    this.rec_params.amount = this.keepPrices(tax_amount);
                }
                //其他费用
            },
            //计算合计
            calculationTableTotal(){
                // return
                let sales_amount = 0;
                let discount_amount = 0;
                let tax_amount = 0;
                let traffic_amount = 0;
                let other_amount = 0;
                let reduce_amount = 0;
                // let receivable_amount = 0.00;
                if(this.listDetail.length>0){
                    this.listDetail.forEach(item=>{
                        if(item.cube&&item.cube_price){
                            // sales_amount += this.keepPrice(Number(item.sales_cube)*Number(item.sales_price))
                            // sales_amount += Number(item.sales_cube)*Number(item.sales_price)
                            this.calcu(item.cube,item.cube_price,"mul",res=>{
                                // this.pl(res)
                                item.total_amount = res;
                                this.calcu(sales_amount,res,"add",val=>{
                                    sales_amount = val
                                },2)
                            },2)
                        }
                    })
                }
                if(this.form_params.rec==1){
                    this.calcu(sales_amount,discount_amount,"reduce",res=>{
                        this.calcu(this.form_params.tax_rate,100,"div",ret=>{
                            this.calcu(res,ret,"mul",val=>{
                                tax_amount = val
                            },2)
                        },4)
                    },2)
                    // tax_amount = this.keepPrice((sales_amount - discount_amount)*(Number(this.form_params.tax_rate)/100))
                }else{
                    tax_amount = 0
                }
                this.tableTotal.sales_amount = sales_amount;
                this.tableTotal.tax_amount = tax_amount;
                this.calcu(sales_amount,tax_amount,"add",a=>{
                    this.tableTotal.receivable_amount = a;
                },2)
            },
            //退货抹零计算
            notCountTheSmallChangeReceiptTotal(){
                if(this.receipt_params.reduce_amount==''){
                    this.receipt_params.amount = this.form_params.unpay_amount;
                }else{
                    this.receipt_params.amount =  this.$bc_sub(Number(this.receipt_params.amount),Number(this.receipt_params.reduce_amount))
                }
            },
            getPurchaseStatusList(){
                this.postFunc("/erp/cloud.purchase.status",{},res=>{
                    this.purchaseStatusList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getBill(){
                this.addDialogVisibleBill = true;
                this.add_billParams.id = this.form_params.id;
            },
            // addOrderBill(){
            //     this.$confirm('是否确认开票?', '提示', {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     }).then(() => {
            //         this.postFuncLoading("/erp/cloud.purchase.invoice",this.add_billParams,()=>{
            //             this.tip("开票成功","success")
            //             this.addDialogVisibleBill = false;
            //             this.getList()
            //         },error=>{
            //             this.tip(error.data.message,"warning")
            //         })
            //     }).catch(()=>{});
            // },
            exportExcelBill(){
                this.$exportExecl("/erp/purchase.order.export","采购单",{id:this.form_params.id})
            },
            payFunc(){
                    let num = 0;
                    let ids = [];
                    if(this.selectRow.length<1){
                        this.tip("请选择数据","warning");
                        return
                    }else if(this.selectRow.length>1){
                        this.tip("请选择单条数据","warning");
                        return
                    }
                    for(let i=0; i<this.selectRow.length;i++){
                        if(this.selectRow[0].supplier_id !=this.selectRow[i].supplier_id){
                            this.tip("付款，供应商必须相同！","warning");
                            return
                        }else{
                            ids.push(this.selectRow[i].id);
                        }
                        num = i;
                    }
                    if(this.selectRow.length>1){
                        this.addDialogVisibleBack = true;
                        this.add_params.ids = ids;
                        this.add_params.supplier_id = this.selectRow[0].supplier_id;
                        this.purchaseShow =false
                    }else if(this.selectRow.length==1){
                        this.add_params.contract_no = this.selectRow[0].contract_no;
                        this.addDialogVisibleBack = true;
                        this.add_params.ids = ids;
                        this.add_params.supplier_id = this.selectRow[0].supplier_id;
                        this.purchaseShow =true
                    }
                // }
            },
            excelExport(){
                this.$exportExecl("/erp/purchase.sales.payments.export","调货应付",this.params)
            },
            print(type){
                let url = "/saleOrderPrint?id=" + this.form_params.id + "&category=" + type;
                window.open(url);
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                if(this.isGlobal){
                    this.filters=[]
                    this.postFunc("/erp/company.column.data",{scene:this.sceneIn},response=>{
                        this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                        this.filters = response.data.data.columns;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else{
                    this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                        this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                        this.filter = response.data.data.columns;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            changeRate(e,input){
                e.target.value=(e.target.value.match(new RegExp("^\\-?\\d*(\\.?\\d{0,2})","g"))[0]) || null
                this.input=e.target.value
                this.add_params.amount=this.input
            },
            //添加收款单
            addReceipt(){
                this.$confirm('是否确认收款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let obj = {};
                    obj.trading_time = parseInt(this.trading_time.getTime()/1000);
                    this.add_receipt.trading_time=parseInt(this.trading_time.getTime()/1000);
                    obj.id = this.add_receipt.id;
                    obj.payment_type_id = this.add_receipt.payment_type_id;
                    obj.account_id = this.add_receipt.account_id;
                    obj.amount = this.add_receipt.amount;
                    obj.files = this.add_receipt.files;
                    obj.remark = this.add_receipt.remark;
                    this.postFuncLoading("/erp/purchase.return.payment",obj,()=>{
                        this.tip("付款成功","success")
                        this.addDialogVisiblereceipt=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //添加付款单
            addOrderSheetBack(){
                this.$confirm('是否确认付款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_params.trading_time=parseInt(this.trading_time.getTime()/1000)
                        this.postFuncLoading("/erp/cloud.finance.pay.amount",this.add_params,()=>{
                            this.tip("付款成功","success")
                            this.addDialogVisibleBack=false;
                            if(this.add_params.ids.length==1){
                                this.getPurchaseInfo(Number(this.add_params.ids));
                            }
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
                this.getList();
            },
            getRow(row){
                this.selectRow=row;
                let number = 0;
                this.selectRow.forEach(item=>{
                    number += Number(item.pay_amount)
                })
                this.select_price = this.keepPrices(number)
            },
            selectAccount(val){
                this.selectMap.account.forEach(item=>{
                    if(item.id==val){
                        this.form_params.bank_no=item.bank_no;
                        this.form_params.account_name=item.account_name;
                        this.form_params.bank_name=item.bank_name;
                    }
                })
            },
            rowClick(obj){
                this.listDetailObj.id=obj.id;
                if(obj.name == "see"){
                    sessionStorage.removeItem("DEMU_ERP_PAYSUMMARY_ID")
                    sessionStorage.setItem("DEMU_ERP_PAYSUMMARY_ID",obj.id)
                    this.$root.$children[0].$children[0].addTab({
                        name: '明细详情'+obj.id,
                        label: '明细详情',
                        content: 'transferDetail'
                    });
                }else if(obj.name=="invoice_yes"){
                    this.seeBillList_id = obj.id;
                    this.dialogVisibleBill = true;
                }else if(obj.name == "contract_no"){
                    this.postFuncLoading("/erp/purchase.sales.payment.info",{id:obj.id},res=>{
                        this.form_params = res.data.data.info;
                        this.supplier_balance = res.data.data.supplier_balance;
                        if(this.form_params.rec == 0){
                            this.form_params.rec =false
                        }else{
                            this.form_params.rec =true
                        }
                        this.form_params.contract_time = res.data.data.info.contract_time * 1000;
                        this.listDetail = res.data.data.details;
                        // this.newFee = res.data.data.list.fee_list;
                        this.sceneIn = 'purchase.sales.payment.info';
                        this.isGlobal = true;
                        this.getBillColumn()
                        if(obj.row.purchase_type==6){
                            this.dialogVisibleB = true;
                        }else{
                            this.dialogVisible = true;
                        }
                        // this.calculationTableTotal()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else if(obj.name == "other_amount"){
                    //其他收款
                    this.listDetailObj.other_amount=obj.row.other_amount;
                    this.listDetailObj.other_amount_remark=obj.row.other_amount_remark;
                    // this.otherVisible =true;
                    this.otherDetailFlag = true;
                }else if(obj.name == "reduce_amount"){
                    //优惠
                    this.listDetailObj.reduce_amount=obj.row.reduce_amount;
                    this.listDetailObj.reduce_amount_remark=obj.row.reduce_amount_remark;
                    this.reduceVisible =true;
                }
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },

            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time = this.formatTimeZero(this.start_time);
                this.params.end_time = this.formatTimeZero(this.end_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/purchase.sales.payments",this.params,response=>{
                    this.last_page=parseInt(response.data.data.list.last_page);
                    // this.params.page=parseInt(response.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(response.data.data.list.total);
                    this.list = response.data.data.list.data;
                    this.totalObj = response.data.data.total;
                    this.list.forEach((item,index)=>{
                        item.see="明细详情";
                        if(item.contract_time!=0){
                            this.list[index].contract_time = this.formatTime(item.contract_time+"000")
                        }else{
                            this.list[index].contract_time = "";
                        }
                        item.isCanClickUnInclude=item.invoice_yes;
                        if(Number(item.settlement_amount)==Number(item.pay_amount)){
                            this.list[index].baseColor="";
                        }else{
                            this.list[index].baseColor="#ff0000";
                        }
                        if(Number(item.pay_amount)==0||Number(item.pay_amount)==''){
                            this.list[index].baseColor="#ff9100";
                        }
                    })
                    this.last_page = response.data.data.list.last_page;
                    this.filter = response.data.data.column;
                    this.copy_filter = JSON.parse(JSON.stringify(response.data.data.column))
                    this.fields=","+(response.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="see"){
                            item.isShow=true;
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPurchaseInfo(id){
                this.postFuncLoading("/erp/purchase.sales.payment.info",{id:id},res=>{
                    this.form_params = res.data.data.info;
                    this.supplier_balance = res.data.data.supplier_balance;
                    if(this.form_params.rec == 0){
                        this.form_params.rec =false
                    }else{
                        this.form_params.rec =true
                    }
                    this.form_params.contract_time = res.data.data.info.contract_time * 1000;
                    this.listDetail = res.data.data.details;
                    // this.newFee = res.data.data.list.fee_list;
                    this.sceneIn = 'purchase.sales.payment.info';
                    this.isGlobal = true;
                    this.getBillColumn()
                    // this.calculationTableTotal()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            changeOther(e,input){
                e.target.value=(e.target.value.match(new RegExp("^\\-?\\d*(\\.?\\d{0,2})","g"))[0]) || null
                this.input=e.target.value
                this.listDetailObj.other_amount=this.input
            },
            changeReduce(e,input){
                e.target.value=(e.target.value.match(new RegExp("^\\-?\\d*(\\.?\\d{0,2})","g"))[0]) || null
                this.input=e.target.value
                this.listDetailObj.reduce_amount=this.input
            },
            outOtherVisible(){
                this.otherVisible =false;
                this.listDetailObj.other_amount='';
            },
            outReduceVisible(){
                this.reduceVisible = false;
                this.listDetailObj.reduce_amount='';
            },
            //其他修改
            otherChangeSure(){
                this.postFunc("/erp/cloud.finance.purchase.update",{
                    id:this.listDetailObj.id,
                    other_amount:this.listDetailObj.other_amount,
                    other_amount_remark:this.listDetailObj.other_amount_remark
                },()=>{
                    this.tip("修改成功","success")
                    this.getList();
                    this.outOtherVisible();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //优惠修改
            reduceChangeSure(){
                this.postFunc("/erp/cloud.finance.purchase.update",{
                    id:this.listDetailObj.id,
                    reduce_amount:this.listDetailObj.reduce_amount,
                    reduce_amount_remark:this.listDetailObj.reduce_amount_remark
                    },()=>{
                    this.tip("修改成功","success")
                    this.getList();
                    this.outReduceVisible();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            search(){
                if (this.params.page == 1) {
                    this.getList()
                } else {
                    this.params.page = 1;
                }
            },

            reset(){
                this.start_time = "";
                this.end_time = "";
                this.params = this.resetSearch(this.params)
                this.getList();
            },
            //打印
            print(){
                let url = "/saleOrderPrint?id=" + this.form_params.id + "&category=" + 5;
                window.open(url);
            },
            change (e) {
                this.$forceUpdate()
            }
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "addDialogVisibleBack":function(val){
                if(!val){
                    this.trading_time = new Date();
                    this.add_params = {ids:[],trading_time:"",account_name:"",supplier_id:"",payment_type_id:"",bill_type:1,course_title:"调货付款",amount:"",remark:"", files:[],}
                    this.fileListShow = [];
                }
            },
            "dialogVisible":function(val){
                if(!val){
                    this.form_params = {id:"",auditor_name: "",contract_no: "",contract_time: "",creator_name: "",cube: "",details: [],order_count: "",remarks: [],supplier: ""};
                    this.listDetail = [];
                }
            },
            "addDialogVisibleBill":function(val){
                if(!val){
                    // this.add_billParams = {id:"",invoice_yes:""}
                    this.add_billParams = {invoice_time:"",title:"",purchase_id:"",contract_no:"",name:"增值税专用发票",code:"",amount:"",remark:""}
                }
            },
            "recChanges":function(val){
                if(!val){
                    this.rec_params = {
                        rec:'',
                        rec_type:'MUL',
                        with_ticket:'',
                        tax_rate:'',
                        amount:'',
                        remark:'',
                    }
                }
            },
            "addOtherDepositDialog":function(val){
                if(!val){
                    this.trading_time = new Date();
                    this.otherDeposit_params={
                        id:'',
                        contract_no:"",
                        trading_time:"",
                        account_id:"",
                        supplier_id:"",
                        payment_type_id:"",
                        bill_type:1,
                        course_title:"其他付款",
                        amount:"",
                        remark:"",
                        files:[],
                    }
                    this.fileListShow = [];
                }
            },
            "addSettlementDialog":function(val){
                if(!val){
                    this.settlement_params={
                        amount:'',
                        remark:'',
                        reduce_amount:'',
                    }
                }
            },
            "addReceiptSettlementDialog":function(val){
                if(!val){
                    this.receipt_params={
                        amount:'',
                        remark:'采购退款到余额',
                        reduce_amount:'',
                    }
                }
            },
            "settlement_params.reduce_amount":function(){
                this.notCountTheSmallChangeTotal();
            },
            "settlement_params.amount":function(){
                this.amountChangeTotal();
            },
        }
    }
</script>
